import {
    Share as ShareIcon,
    Email as EmailIcon,
    Facebook as FacebookIcon,
    LinkedIn as LinkedInIcon,
    Twitter as TwitterIcon,
} from '@mui/icons-material';
import {
    Box,
    Button,
    Container,
    Popover,
    Stack,
    useMediaQuery,
} from '@mui/material';
import { useState, MouseEvent, useContext } from 'react';
import {
    EmailShareButton,
    FacebookShareButton,
    LinkedinShareButton,
    TwitterShareButton,
} from 'react-share';

import { SharePollContent } from '../../../../content/share_poll_content';
import { PollRecord } from '../../../../models/Poll';
import { breakpoint4 } from '../../../../utils/layouts';
import { RoutePaths } from '../../../core/AppRouter/AppRouter';

import './SharePoll.scss';
import {
    SessionContext,
    SessionContextType,
} from '../../../../contexts/session';
import {
    AnonymousUserContext,
    AnonymousUserContextType,
} from '../../../../contexts/anonUser';

interface SharePollProps {
    poll: PollRecord;
}

const SharePoll = (props: SharePollProps): JSX.Element => {
    const { session } = useContext<SessionContextType>(SessionContext);
    const { anonUser } =
        useContext<AnonymousUserContextType>(AnonymousUserContext);
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const baseURL = new URL(window.location.href).origin;
    const shareURL = `${baseURL}/${RoutePaths.Poll.replace(
        ':pollId',
        props.poll.id,
    )}?ref=${String(session.user?.id ?? anonUser.user?.id)}`;
    const mobileLandscapePlus = useMediaQuery(breakpoint4);

    const onClickHandler = (event: MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
        event.stopPropagation();
    };

    const onMouseLeaveHandler = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <Button
                variant='outlined'
                className='poll-share'
                onClick={onClickHandler}
            >
                <ShareIcon />
                {mobileLandscapePlus && (
                    <Container className='poll-share-text'>Share</Container>
                )}
            </Button>
            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                onClose={onMouseLeaveHandler}
                disableRestoreFocus
            >
                <Box className='poll-share-popover'>
                    <Stack direction='row' spacing={2}>
                        <FacebookShareButton
                            url={shareURL}
                            quote={SharePollContent.facebook.quote}
                        >
                            <FacebookIcon fontSize='large' />
                        </FacebookShareButton>
                        <LinkedinShareButton
                            url={shareURL}
                            title={SharePollContent.linkedin.title}
                            summary={SharePollContent.linkedin.summary}
                            source={SharePollContent.linkedin.source}
                        >
                            <LinkedInIcon fontSize='large' />
                        </LinkedinShareButton>
                        <TwitterShareButton
                            url={shareURL}
                            title={SharePollContent.twitter.title}
                        >
                            <TwitterIcon fontSize='large' />
                        </TwitterShareButton>
                        <EmailShareButton
                            url={shareURL}
                            subject={SharePollContent.email.subject}
                            body={SharePollContent.email.body}
                        >
                            <EmailIcon fontSize='large' />
                        </EmailShareButton>
                    </Stack>
                </Box>
            </Popover>
        </>
    );
};

export default SharePoll;
